import { jsx } from "panel";
import { ServerErrorHero } from "common/widgets/warning-hero/presets";
import { WarningHeroReportName } from "common/widgets/warning-hero/constants";
import { UsersTableEl } from "common/widgets/users-table";
import { SpinnerEl } from "common/components/spinner";
import { InputEl } from "common/components/input";
import { ButtonEl } from "common/components/button";
import { ButtonLayout, ButtonTheme } from "common/components/button/constants";
import { CreateCohortButtonEl } from "common/widgets/create-cohort-button";
import { pluralize } from "common/util/string";
import { currentProjectStore } from "common/report/stores/project-details";
import { Permission } from "common/report/constants";
import { TooltipEl } from "common/components/tooltip";
import { TrackingEvent } from "../tracking";
export function template() {
  var _a, _b;
  const segments = this.attr(`segments`);
  const { loadingCount, totalUsers = 0, loading, users, error, cohort } = this.state;
  const dgContext = this.attr(`data-group-name`) === `user` ? `user` : void 0;
  const { t, print } = this.getContext(`i18n`);
  return /* @__PURE__ */ jsx("div", { sel: ".wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".header" }, /* @__PURE__ */ jsx("h2", null, t(`view-users.title`, {
    context: dgContext,
    group: pluralize(this.attr(`data-group-name`), true)
  }), ((_a = this.attr(`data-group-name`)) == null ? void 0 : _a.length) > 25 && /* @__PURE__ */ jsx(
    TooltipEl,
    {
      attrs: {
        text: `View ${pluralize(this.attr(`data-group-name`), true)}`
      }
    }
  )), /* @__PURE__ */ jsx("slot", null)), /* @__PURE__ */ jsx("div", { sel: ".info" }, /* @__PURE__ */ jsx("h3", null, /* @__PURE__ */ jsx("span", { sel: ".color", style: { background: this.attr(`color`) } }), segments.join(` / `)), /* @__PURE__ */ jsx("p", null, !loadingCount ? totalUsers.toLocaleString() : /* @__PURE__ */ jsx(SpinnerEl, null), ` `, this.params.createSegmentLabel ? print(
    this.params.createSegmentLabel({
      context: this.attr(`data-group-name`),
      count: totalUsers,
      group: pluralize(this.attr(`data-group-name`), totalUsers)
    })
  ) : t(`view-users.count-label`, {
    context: dgContext,
    count: totalUsers,
    group: pluralize(this.attr(`data-group-name`), totalUsers)
  })), /* @__PURE__ */ jsx("div", { sel: ".actions" }, /* @__PURE__ */ jsx(
    ButtonEl,
    {
      attrs: {
        theme: ButtonTheme.Tertiary,
        icon: `export-csv`,
        layout: ButtonLayout.Vertical
      },
      on: {
        click: this.handleDownloadCsv
      }
    },
    t(`view-users.export-csv`)
  ), ((_b = currentProjectStore.value) == null ? void 0 : _b.hasPermission(Permission.WriteCohorts)) && !this.attr(`hide-cohort-functionality`) && /* @__PURE__ */ jsx(
    CreateCohortButtonEl,
    {
      attrs: {
        label: t(`view-users.create-cohort`),
        icon: `community`,
        theme: ButtonTheme.Tertiary,
        layout: ButtonLayout.Vertical,
        "show-upsell-in-dropdown": true
      },
      props: {
        cohortDetails: this.state.cohortDetails
      },
      on: {
        create: this.handleCohortEvent(TrackingEvent.CreateCohort),
        save: this.handleCohortEvent(TrackingEvent.SaveCohort)
      }
    }
  ))), /* @__PURE__ */ jsx("div", { sel: ".search" }, /* @__PURE__ */ jsx(
    InputEl,
    {
      attrs: {
        icon: `search`,
        placeholder: t(`view-users.search-placeholder`),
        "show-clear": true,
        "auto-focus": true
      },
      style: { width: `100%` },
      on: { input: this.handleSearch, clear: this.handleSearch }
    }
  )), /* @__PURE__ */ jsx("div", { sel: ".content" }, error && /* @__PURE__ */ jsx(ServerErrorHero, { reportName: WarningHeroReportName.Users }), (loading || !error) && /* @__PURE__ */ jsx(
    UsersTableEl,
    {
      attrs: {
        "data-group-id": cohort.dataGroupId || ``,
        loading,
        "is-select-enabled": false,
        "showing-properties": this.getShowingProperties(),
        "sensitive-properties": [],
        "default-sort-field": { value: `$last_seen` },
        "default-sort-order": -1,
        "emit-row-click": true,
        compact: true
      },
      props: {
        rows: users.map((user) => ({
          $distinct_id: user.$distinct_id,
          ...user.$properties
        }))
      },
      on: {
        userSelected: this.handleUserSelected
      }
    }
  )));
}
